import 'css-chunk:src/app/components/AutomationAuditTable/useAutomationAuditTableColumns.scss';export default {
  "AutomationButton": "_AutomationButton_1put8_1",
  "ConfirmationModal": "_ConfirmationModal_1put8_7"
};